import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { clearSelectedAdAccountIfNotFound, handleGql403 } from '../../../../../utils';
import { MutationUpdateLastActivityArgs } from '../../../types';
import { UPDATE_LAST_ACTIVITY } from './updateLastActivity';

type UpdateLastActivity = {
  handleUpdateLastActivity: (adAccountId: string) => Promise<void>;
  loading: boolean;
};

export const operationName = 'updateLastActivity';

const useUpdateLastActivity = (): UpdateLastActivity => {
  const [updateLastActivity, { loading }] = useMutation<MutationUpdateLastActivityArgs>(UPDATE_LAST_ACTIVITY);

  const handleUpdateLastActivity = useCallback(
    async (adAccountId: string): Promise<void> => {
      if (adAccountId) {
        try {
          await updateLastActivity({
            variables: {
              adAccountId,
            },
            onError: handleGql403,
          });
        } catch (error) {
          clearSelectedAdAccountIfNotFound(error, adAccountId);
        }
      }
    },
    [updateLastActivity]
  );

  return {
    handleUpdateLastActivity,
    loading,
  };
};

export default useUpdateLastActivity;
